import { render, staticRenderFns } from "./CreateProjectFromTemplate.vue?vue&type=template&id=6d2684e8&"
import script from "./CreateProjectFromTemplate.vue?vue&type=script&lang=js&"
export * from "./CreateProjectFromTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports